
import { useContext, useEffect, useState } from "react";
import Logo from "../../assets/images/logo.png";
import patern from "../../assets/images/loginHeroImage.jpg";
import { MyContext } from "../../App";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle, FaPhoneAlt } from "react-icons/fa";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import CircularProgress from "@mui/material/CircularProgress";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { firebaseApp } from "../../firebase";
import googleIcon from "../../assets/images/googleIcon.png";
import { postData } from "../../utils/api";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

const SignUp = () => {
  const [inputIndex, setInputIndex] = useState(null);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isShowConfirmPassword, setIsShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formfields, setFormfields] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    isAdmin: true,
  });

  const history = useNavigate();
  const context = useContext(MyContext);

  useEffect(() => {
    context.setisHideSidebarAndHeader(true);
    window.scrollTo(0, 0);
  }, []);

  const focusInput = (index) => setInputIndex(index);

  const onchangeInput = (e) => {
    setFormfields((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const signUp = (e) => {
    e.preventDefault();

    if (!formfields.name.trim()) {
      context.setAlertBox({ open: true, error: true, msg: "Name cannot be blank!" });
      return;
    }
    if (!formfields.email.trim()) {
      context.setAlertBox({ open: true, error: true, msg: "Email cannot be blank!" });
      return;
    }
    if (!formfields.phone.trim()) {
      context.setAlertBox({ open: true, error: true, msg: "Phone cannot be blank!" });
      return;
    }
    if (!formfields.password) {
      context.setAlertBox({ open: true, error: true, msg: "Password cannot be blank!" });
      return;
    }
    if (!formfields.confirmPassword) {
      context.setAlertBox({ open: true, error: true, msg: "Confirm password cannot be blank!" });
      return;
    }
    if (formfields.password !== formfields.confirmPassword) {
      context.setAlertBox({ open: true, error: true, msg: "Passwords do not match!" });
      return;
    }

    setIsLoading(true);
    postData("/api/user/signup", formfields)
      .then((res) => {
        if (res.status !== "FAILED") {
          localStorage.setItem("userEmail", formfields.email);
          setTimeout(() => {
            setIsLoading(false);
            history("/verify-account");
          }, 2000);
        } else {
          setIsLoading(false);
          context.setAlertBox({ open: true, error: true, msg: res.msg });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        context.setAlertBox({ open: true, error: true, msg: "Something went wrong!" });
        console.error(error);
      });
  };

  const signInWithGoogle = () => {
    signInWithPopup(auth, googleProvider)
      .then((result) => {
        const user = result.user.providerData[0];
        const fields = {
          name: user.displayName,
          email: user.email,
          password: null,
          images: user.photoURL,
          phone: user.phoneNumber,
          isAdmin: true,
        };
        postData("/api/user/authWithGoogle", fields).then((res) => {
          if (!res.error) {
            localStorage.setItem("token", res.token);
            localStorage.setItem(
              "user",
              JSON.stringify({
                name: res.user?.name,
                email: res.user?.email,
                userId: res.user?.id,
              })
            );
            context.setAlertBox({ open: true, error: false, msg: res.msg });
            setTimeout(() => {
              context.setIsLogin(true);
              history("/dashboard");
            }, 2000);
          } else {
            context.setAlertBox({ open: true, error: true, msg: res.msg });
          }
        });
      })
      .catch((error) => {
        context.setAlertBox({ open: true, error: true, msg: error.message });
      });
  };

  return (
    <>
      {/* tsParticles Background */}
      <Particles
        id="tsparticles"
        init={async (main) => {
          await loadFull(main);
        }}
        options={{
          fullScreen: { enable: false },
          background: {
            color: { value: "#f0f4f8" },
          },
          particles: {
            number: {
              value: 50,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: "#1976d2",
            },
            shape: {
              type: "circle",
            },
            opacity: {
              value: 0.5,
              random: true,
            },
            size: {
              value: 5,
              random: true,
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              outModes: {
                default: "out",
              },
            },
          },
          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: "repulse",
              },
            },
            modes: {
              repulse: {
                distance: 100,
                duration: 0.4,
              },
            },
          },
        }}
        style={{
          position: "fixed",
          zIndex: -1,
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />

      {/* Your Existing Signup UI */}
      <section className="loginSection">
        <div className="loginContainer">
          <div className="loginBox">
            <Link to="/" className="logo">
              <img src={Logo} alt="Logo" />
              <h1>ECOMMERCE</h1>
              <small>Sign Up</small>
            </Link>

            <form onSubmit={signUp}>
              {/* All Input Fields */}
              {/* Name */}
              <div className={`form-group ${inputIndex === 0 ? "focus" : ""}`}>
                <span className="icon"><FaUserCircle /></span>
                <input type="text" placeholder="Enter your name" name="name" onFocus={() => focusInput(0)} onBlur={() => setInputIndex(null)} onChange={onchangeInput} autoComplete="name" />
              </div>

              {/* Email */}
              <div className={`form-group ${inputIndex === 1 ? "focus" : ""}`}>
                <span className="icon"><MdEmail /></span>
                <input type="email" placeholder="Enter your email" name="email" onFocus={() => focusInput(1)} onBlur={() => setInputIndex(null)} onChange={onchangeInput} autoComplete="email" />
              </div>

              {/* Phone */}
              <div className={`form-group ${inputIndex === 2 ? "focus" : ""}`}>
                <span className="icon"><FaPhoneAlt /></span>
                <input type="tel" placeholder="Enter your phone" name="phone" onFocus={() => focusInput(2)} onBlur={() => setInputIndex(null)} onChange={onchangeInput} autoComplete="tel" />
              </div>

              {/* Password */}
              <div className={`form-group ${inputIndex === 3 ? "focus" : ""}`}>
                <span className="icon"><RiLockPasswordFill /></span>
                <input type={isShowPassword ? "text" : "password"} placeholder="Enter your password" name="password" onFocus={() => focusInput(3)} onBlur={() => setInputIndex(null)} onChange={onchangeInput} autoComplete="new-password" />
                <span className="toggleShowPassword" onClick={() => setIsShowPassword(!isShowPassword)}>{isShowPassword ? <IoMdEyeOff /> : <IoMdEye />}</span>
              </div>

              {/* Confirm Password */}
              <div className={`form-group ${inputIndex === 4 ? "focus" : ""}`}>
                <span className="icon"><IoShieldCheckmarkSharp /></span>
                <input type={isShowConfirmPassword ? "text" : "password"} placeholder="Confirm your password" name="confirmPassword" onFocus={() => focusInput(4)} onBlur={() => setInputIndex(null)} onChange={onchangeInput} autoComplete="new-password" />
                <span className="toggleShowPassword" onClick={() => setIsShowConfirmPassword(!isShowConfirmPassword)}>{isShowConfirmPassword ? <IoMdEyeOff /> : <IoMdEye />}</span>
              </div>

              {/* Submit */}
              <div className="form-group">
                <Button type="submit" className="btn-blue btn-lg w-100 btn-big" disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} /> : "Sign Up"}
                </Button>
              </div>

              {/* Google */}
              <div className="divider">
                <span></span><span>or</span><span></span>
              </div>
              <Button variant="outlined" className="w-100 btn-lg btn-big loginWithGoogle" onClick={signInWithGoogle}>
                <img src={googleIcon} width="25px" alt="Google Icon" /> &nbsp; Sign Up with Google
              </Button>

              {/* Already have an account */}
              <div className="registerText">
                Already have an account?
                <Link to="/login" className="ml-1">Sign In</Link>
              </div>
            </form>
          </div>

          <div className="heroImageWrapper">
            <img src={patern} alt="Hero" />
          </div>
        </div>
      </section>



      <style jsx="true">{`
        #tsparticles {
          position: fixed;
          z-index: -1;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #f0f4f8;
        }
        .loginSection {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          background: transparent;
        }
        .loginContainer {
          display: flex;
          max-width: 900px;
          width: 100%;
          border-radius: 20px;
          overflow: hidden;
          background: white;
          box-shadow: 0 15px 25px rgba(0, 0, 0, 0.2);
          transition: box-shadow 0.3s ease;
        }
        
        .loginBox {
          flex: 1 1 400px;
          background: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-radius: 20px 0 0 20px;
          padding: 40px 35px;
        }
        .logo {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 25px;
          user-select: none;
        }
        .logo img {
          width: 120px;
          filter: drop-shadow(0 0 3px rgba(25, 118, 210, 0.5));
        }
        .logo h1 {
          font-weight: 700;
          font-size: 2.2rem;
          margin-top: 15px;
          color: #1976d2;
        }
        .logo small {
          font-size: 1rem;
          color: #666;
          font-weight: 500;
          margin-top: 5px;
        }
        form {
          width: 100%;
          height: auto;
        }
        .form-group {
          position: relative;
          margin-bottom: 20px;
           
        }
        .form-group .icon {
          position: absolute;
          top: 50%;
          left: 18px;
          transform: translateY(-50%);
          color: #1976d2;
          font-size: 20px;
          transition: color 0.3s ease;
          pointer-events: none;
        }
        .form-group.focus .icon,
        .form-group input:focus + .icon {
          color: #004ba0;
        }
        .form-group input {
          width: 100%;
          padding: 8px 50px 8px 50px;
          border: 2px solid #ddd;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 500;
          color: #222;
          background-color: #f9fafb;
          transition: all 0.3s ease;
          box-shadow: inset 0 2px 4px rgb(0 0 0 / 0.05);
        }
        .form-group input::placeholder {
          color: #999;
          font-weight: 400;
        }
        .form-group input:focus {
          border-color: #1976d2;
          background-color: #fff;
          outline: none;
          box-shadow: 0 0 8px rgba(25, 118, 210, 0.4);
        }
        .toggleShowPassword {
          position: absolute;
          right: 18px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          color: #1976d2;
          font-size: 22px;
          transition: color 0.3s ease;
          user-select: none;
        }
        .toggleShowPassword:hover {
          color: #004ba0;
        }
        .btn-blue {
          background-color: #1976d2;
          color: white;
          font-weight: 600;
          border-radius: 12px !important;
          text-transform: none;
          padding: 12px 0;
        }
        .btn-blue:hover {
          background-color: #004ba0;
        }
        .btn-lg {
          font-size: 1.1rem;
          padding: 14px 0;
        }
        .btn-big {
          width: 100%;
        }
        .divider {
          display: flex;
          align-items: center;
          text-align: center;
          margin: 28px 0;
          color: #bbb;
          font-weight: 600;
          font-size: 0.95rem;
        }
        .divider span {
          flex: 1;
          border-bottom: 1.5px solid #ddd;
          line-height: 0.1em;
          margin: 0 10px;
        }
        .loginWithGoogle {
          border-radius: 12px !important;
          font-weight: 600;
          color: #1976d2 !important;
          text-transform: none !important;
        }
        .loginWithGoogle:hover {
          border-color: #004ba0 !important;
          color: #004ba0 !important;
          background-color: #e3f2fd !important;
        }
        .registerText {
          text-align: center;
          margin-top: 30px;
          font-weight: 600;
          font-size: 1rem;
          color: #555;
          user-select: none;
        }
        .registerText a {
          color: #1976d2;
          text-decoration: none;
          font-weight: 700;
          margin-left: 5px;
          transition: color 0.3s ease;
        }
        .registerText a:hover {
          color: #004ba0;
          text-decoration: underline;
        }
        .heroImageWrapper {
          flex: 1 1 400px;
          background: #1976d2;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0 20px 20px 0;
          overflow: hidden;
          transition: filter 0.3s ease;
        }
        .heroImageWrapper img {
          max-width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(1);
          transition: filter 0.3s ease;
        }
        .loginContainer:hover .heroImageWrapper img {
          filter: brightness(0.85);
        }

        @media (max-width: 767px) {
          .loginContainer {
            flex-direction: column;
            border-radius: 20px;
            max-width: 420px;
          }
          .loginBox,
          .heroImageWrapper {
            border-radius: 20px;
            flex: none;
            width: 100%;
          }
          .heroImageWrapper {
            height: 240px;
          }
        }
      `}</style>
    </>
  );
};

export default SignUp;
